import React, { useEffect, useState } from "react";
import { signIn, logOut, auth } from "../functions/firebaseFunctions";
import { onAuthStateChanged } from "firebase/auth";

export default function LogIn() {

    const [user, setUser] = useState(undefined);

    useEffect(() => {
        onAuthStateChanged(auth, (user) => {
            if (user) {
                setUser(user)
            } else {
                setUser('not signed in');
            }
        });
    }, []);

    const inputStyle = {
        width: '100%',
    }
    const [error, setError] = useState(null);
    return (
        <section style={{
            width: '100vw',
            height: '100vh',
            backgroundColor: 'var(--ltGreen)',
            display: 'grid',
            placeItems: 'center',
        }}>
            {user === undefined ?
                <h1>Loading...</h1>
                :
                user === 'not signed in' ?
                    <div>
                        <h1>Login</h1>
                        <hr />
                        {error && <div className="errMsg">{error.message}</div>}
                        <form onSubmit={event => {
                            signIn(event).then(signInRes => {
                                if (signInRes.succsess) {
                                    setUser(signInRes.user);
                                } else { setError(signInRes) }
                            });
                        }}
                            style={{
                                display: 'grid',
                                placeItems: 'center',
                                gap: 10,
                                minWidth: 300
                            }}>
                            <input
                                name='email'
                                autoComplete="email"
                                autoCapitalize="none"
                                placeholder="E-mail"
                                style={inputStyle}
                                onFocus={() => setError(null)}
                            />
                            <input
                                name='password'
                                autoComplete="password"
                                autoCapitalize="none"
                                placeholder="Password"
                                type="password"
                                style={inputStyle}
                                onFocus={() => setError(null)}
                            />
                            <button type="submit" className="popUp btn" style={{
                                width: '100%',

                            }}>Login</button>
                        </form>
                    </div>
                    :
                    <div>
                        <h1>Already Signed In</h1>
                        <button type="button" className="popUp btn" style={{ width: '100%' }}
                            onClick={logOut}>Logout</button>
                    </div>
            }
        </section>
    )
}